import { Upload } from '@creditornot/cb-icons';
import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import styled from 'styled-components';

import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';
import { useListingManagerRoutes } from 'modules/shared-menu/hooks/useListingManagerRoutes';
import { ColumnsPickerModal } from 'modules/shared-menu/pages/GoogleSheetsImportPage/components/ColumnsPickerModal';
import { ColumnsToDisplay } from 'modules/shared-menu/pages/GoogleSheetsImportPage/components/DataTable/useDataTable';
import { SheetNameToShapedLinesMap } from 'modules/shared-menu/pages/GoogleSheetsImportPage/libs/googleSheets';

import ActionButton from './ActionButton';

const Download = styled(Upload)`
  transform: rotate(180deg);
`;

type BulkExportToGoogleSheetsProps = {
  selectedIds: Set<string>;
  hasWoltSpecialInSelectedIds: boolean;
};

export const BulkExportToGoogleSheets = ({
  selectedIds,
  hasWoltSpecialInSelectedIds,
}: BulkExportToGoogleSheetsProps) => {
  const [isColumnsPickerOpen, setIsColumnsPickerOpen] = useState(false);
  const menuPermissions = useOfferingMenuPermissionsContext();
  const { menuEditorGoogleSheetsImportPage } = useListingManagerRoutes();

  const history = useHistory();

  const handleOnConfirmClick = useCallback(
    (columnsToDisplay: ColumnsToDisplay) => {
      const selectedFields = {
        offers: columnsToDisplay.offers.map(({ value }) => value),
        options: columnsToDisplay.options.map(({ value }) => value),
        categories: columnsToDisplay.categories.map(({ value }) => value),
      } as SheetNameToShapedLinesMap;

      history.push(`${menuEditorGoogleSheetsImportPage()}?bulkActionsExport=true`, { selectedIds, selectedFields });
    },
    [history, menuEditorGoogleSheetsImportPage, selectedIds],
  );

  return (
    <>
      <ActionButton
        disabled={!menuPermissions.contentEdit || hasWoltSpecialInSelectedIds}
        icon={<Download />}
        onClick={() => setIsColumnsPickerOpen(true)}
        tooltipTitle={
          hasWoltSpecialInSelectedIds ? (
            <FormattedMessage id="menu.bulkActions.googleSheets.disabledLabel" />
          ) : (
            <FormattedMessage id="shared-menu.editor.centralised-actions.bulk-update.google-sheets-export" />
          )
        }
      />
      {isColumnsPickerOpen && (
        <ColumnsPickerModal
          onClose={() => setIsColumnsPickerOpen(false)}
          onConfirm={handleOnConfirmClick}
          hideControls
        />
      )}
    </>
  );
};
